import { render, staticRenderFns } from "./CoozzyMoreIcon.vue?vue&type=template&id=7e7c7a56&scoped=true"
import script from "./CoozzyMoreIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyMoreIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyMoreIcon.vue?vue&type=style&index=0&id=7e7c7a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7c7a56",
  null
  
)

export default component.exports